import React, { useState,useEffect } from "react";
import Modal from "react-modal";
import { HTTP } from "./../api/http-common";
import Swal from "sweetalert2";

function CategoryModal({showModal,setShowModal,formData, setFormData,fetchTableData}) {
    const [nameError, setNameError] = useState("");
    const resetValidationErrors = () => {
        setNameError('');
    };
    const validateField = () => {
        resetValidationErrors();
    
        let checked = true;
          if (formData.name === '') {
            setNameError('Please enter name');
              if (checked) {
                  checked = false;
              }
          } else if ((formData.name).length < 5) {
            setNameError("Please enter minimum 5 characters");
              if (checked) {
                  checked = false;
              }
          } else if ((formData.name).length > 100) {
            setNameError("Max character limit is 100");
              if (checked) {
                  checked = false;
              }
          }
          

        return checked;
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    const handleAddEdit = async (event) => {
        event.preventDefault();
        if (validateField()) {
          // const formData = new FormData(event.target);
          try {
            const access_token = localStorage.getItem("access_token");
            let config = {
              headers: { "Content-Type": "application/json", token: access_token },
            };
        
            await HTTP.post("/business_cate/add_business_category", formData, config)
              .then((response) => {
                if (response.status === 200) {
                //   console.log(response.data)
                  // alert("Coupon added successfully");
                  Swal.fire(response.data.message);
                  
                  // Close the modal after coupon is added
                  setShowModal(false);
    
                  fetchTableData();
                  // navigate("/coupons"); // Navigate to the /coupon page
                }
              })
              .catch((error) => {
                Swal.fire("Error", "There was an error adding/updating the coupon.", "error");
                if (error.response && error.response.status === 406) {
                  Swal.fire({
                    title: 'Error!',
                    text: error.response.data.detail,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
                }
              });
          } catch (error) {
            Swal.fire("Error", "There was an unexpected error.", "error");
          }
        }
        
      };
      const styles = {
        modal: {
            content: {
            padding: '30px',
            borderRadius: '10px',
            backgroundColor: '#fff',
            maxWidth: '600px',
            margin: 'auto',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            position:'absolute'
            },
        },
        }
  return (
    <>
    {/* Start Model to add form  */}
    <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        contentLabel="Add"
        style={styles.modal}
      >
        <div className="flex flex-col space-y-1.5 text-center sm:text-left">
        <h2 id="radix-:rg:" className="text-lg font-semibold leading-none tracking-tight">
          Add / Update Category
        </h2>
        <p id="radix-:rh:" className="text-sm text-muted-foreground">
          Create a new category by filling out the form below.
        </p>
      </div>
        {/* Coupon form */}
        <form className="space-y-8ReactModal__Overlay ReactModal__Overlay--after-open custom-overlay-position" onSubmit={handleAddEdit}>
        <div className="grid grid-cols-2 gap-4">
          {/* Name Input */}
          <div className="space-y-2">
            <label
              htmlFor=":r1r:-form-item"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Name
            </label>
            <div className="relative space-y-1">
              <input
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                placeholder="Enter Name"
                name="name"
                id=":r1r:-form-item"
                aria-describedby=":r1r:-form-item-description"
                aria-invalid="false"
                value={formData.name}
              onChange={handleChange}
              />
              {nameError && <span className="text-sm text-red-500">{nameError}</span>}
            </div>
          </div>

        </div>
          <div className="flex items-center justify-evenly">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg my-2  mr-2"
            type="submit"
          >
            Submit
          </button>
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 my-2"
            type="button"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>
      </form>

      </Modal>

    </>
  )
}

export default CategoryModal